<template>
  <div id="app" :class="{
    'night-mode' : nightModeEnabled,
    /* 'flex-grid' : flexGridEnabled */
  }">
    <!--
    userReadonly: {{userReadonly}}
    initialized: {{initialized}}
    loggedIn: {{loggedIn}}
    goals_loaded: {{goals_loaded}}
    calendar_loaded: {{calendar_loaded}}
    -->

    <template v-if="loggedIn === undefined || ( loggedIn && !$ready_goals ) || userReadonly.status === 'loading'" >
      <!-- loading, TODO: move this to a layout that is always used when logged in -->
      <div class="app-loading-text" style="padding-top: 200px">
        <template v-if="num_of_goals_ready_all > 0">
          {{num_of_goals_ready_loaded}} / {{num_of_goals_ready_all}} Goals loaded.
        </template>
        <template v-else>
          Loading Goalpilot, prepare for take-off
        </template>
        <br /><br />
        <!-- <img src="@/assets/logo_b.svg" alt="Goalpilot" height="100" class="pulse" /> -->
        <!-- <Spinner class="p-8 mt-4" size="huge" /> -->
        <div v-if="!is_production" class="loader-debug">DEBUG: {{resourcesReady}}</div>
      </div>
    </template>

    <template v-else-if="/*!loggedIn ||*/ $route.meta.layout === 'empty'">
      <!-- The only reason, whe we have to check second and not first, is redirect from google auth case! -->
      <empty-layout />
    </template>

    <template v-else-if="/*waitingForContent || */ userReadonly.status === 'init' || userReadonly.status === 'creating'">
      <WaitingForAccount />
    </template>

    <template v-else-if="userReadonly.status === 'inactive' || userReadonly.status === 'deleted'">
      <div>
        Account inactive or deleted
      </div>
    </template>

    <template v-else-if="userReadonly.status === 'active'">
      <default-layout />
    </template>

    <template v-else>
      <!-- TODO -->
      <div
        class="main-container"
        style="background-image: linear-gradient(rgb(255, 255, 255), rgb(235, 243, 255));">
      </div>
    </template>

    <div
      class="overlay"
      :style="{ display: show_overlay ? 'block' : 'none' }"></div>
    <Modals v-if="loggedIn" />
    <portal-target name="modal-target-goal-details"></portal-target>
    <DocumentTitleUpdater />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import Spinner from "vue-simple-spinner";
import Modals from '@/components/Modals/Modals';
import DefaultLayout from '@/layouts/default';
import EmptyLayout from '@/layouts/empty';
import resourceLoader from '@/resource-loader'
import DocumentTitleUpdater from "@/components/Elements/DocumentTitleUpdater"
import WaitingForAccount from "@/pages/Login/WaitingForAccount";

import { mapReady } from '@/api/misc'
// TODO: Read layout from route.js and use dynamic component

// TODO: loggedIn -> $ready_auth

export default {
  name: "App",
  data() {
    return {
      defaultUserId: null,
      show_overlay: false,
      waitingForContent: false,
      is_production: process.env.VUE_APP_PRODUCTION !== 'false',
    };
  },
  beforeCreate() {
    resourceLoader.afterAppStartsLoading();
  },
  created() {
    // this.defaultUserId = this.$models.user.defaultUserId;
  },
  mounted() {
    resourceLoader.afterAppMounted()

    /* Init dayplanner */
    this.initializeDayplanner();

    if (!(window.chrome || (navigator.userAgent.match('CriOS')))) {
      this.$notify.warning({
        type: 'warning',
        message: 'Goalpilot (beta) is optimized for the Chrome Desktop. For your best user experience it is recommended to use that browser.',
        duration: 0,
      });
    }
  },
  watch: {
    '$ready_auth' () {
      this.defaultUserId = this.$models.user.defaultUserId;
    },
    '$ready_user' () {
      // console.log("user is ready")
      resourceLoader.afterUserReady()
    },
    '$ready_goals' () {
      // remove 'body-loading' class that was added in html template
      document.body.classList.remove('body-loading');

      // Remove animation
      document.querySelector('#mount').remove()
    },
    userReadonly: {
      handler( newUserReadonly, oldUserReadonly ) {
        // oldUserReadonly.status won't work!

        if ( newUserReadonly.status === 'init' || newUserReadonly.status === 'creating' ) {
          this.waitingForContent = true;
        }

        if ( newUserReadonly.status === 'active' && this.waitingForContent ) {
          /* User has just been activated */
          resourceLoader.afterUserContentCreated( newUserReadonly ).then(() => {
            this.waitingForContent = false;
          })
        }

        if ( /*( oldUserReadonly.status && newUserReadonly['.exists'] === false )
          ||*/ newUserReadonly.status === 'deleted'
          || newUserReadonly.status === 'inactive' ) {
          /* User was deleted on server side */
          console.log("**** BOOM - USER TERMINATED ****")
          this.$api.auth_logout()
          this.$router.push('/login')
        }
      },
      deep: true
    },
    showOnboarding: {
      handler( value ) {
        if ( value ) {
          this.$root.showUpdateModal('init-setup');
        }
      }
    }
  },
  computed: {
    ...mapReady('auth', 'user', 'goals'),
    // ...mapGetters("app", [
    //   "flexGridEnabled",
    // ]),
    ...mapGetters("user", [
      "loggedIn",
    ]),

    num_of_goals_ready_all() {
      // TODO: Does not work
      return this.$models.goalMeta.getters.all_goals_user
        ? Object.keys( this.$models.goalMeta.getters.all_goals_user ).length
        : -1
    },

    num_of_goals_ready_loaded() {
      // TODO: Does not work
      return this.$models.goalMeta.getters.all_goals_loaded.length
      // return this.$api.get_ready_count('goal')
    },

    resourcesReady() {
      // DEBUG !
      return Object.keys(this.$api.get_registry().state.ready).filter(entry => {
        return true;
      })
    },

    userExists() {
      if ( this.defaultUserId ) {
        let userSettings = this.$models.userSettings.getData( this.defaultUserId, true )
        return !userSettings['.exists']
      } else {
        return false
      }
    },

    nightModeEnabled() {
      if ( this.defaultUserId && this.$ready_user ) {
        let userSettings = this.$models.userSettings.getData( this.defaultUserId, true )
        if ( userSettings && userSettings.settings && userSettings.settings.nightMode ) {
          return userSettings.settings.nightMode
        }
      }
      return false
    },

    userReadonly() {
      if ( !this.loggedIn ) {
        return { status: null }
      }
      if ( this.defaultUserId && this.$ready_user ) {
        return this.$models.userReadonly.subscribeNode( this.defaultUserId )
      }
      return { status: 'loading' }
    },

    showOnboarding() {
      if ( !this.defaultUserId ) {
        return false
      }

      let userSettings = this.$models.userSettings.getData( this.defaultUserId, true )

      return userSettings.showOnboarding
          && this.loggedIn
          && this.userReadonly
          && this.userReadonly.status === 'active'
    },
  },
  methods: {
    ...mapActions("dayplanner", [
      'initializeDayplanner',
    ]),
  },
  components: {
    // Spinner,
    DefaultLayout,
    EmptyLayout,
    Modals,
    DocumentTitleUpdater,
    WaitingForAccount,
  }
};
</script>

<style lang="scss">
.overlay {
  display: none;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  background: #000;
  opacity: 0.75;
  filter: alpha(opacity = 75); /* required for opacity to work in IE */
  z-index: 1;
}

// .flex-grid {
//   display: grid;
//   /* // grid-template-rows: $appbar-height $navbar-height 1fr; */
//   grid-template-columns: auto;
//   grid-template-rows: 45px 1fr;
//   /*
//   // grid-template-areas:
//   //   "nav"
//   //   "lists";
//   */
//   height: 100vh;
// }

/*.page-container {
  background-color: white;
  margin: 0;
  width: 100%;
  height: 100vh;
}*/

.page-container {
  margin: 0.5em auto;
  width: 90%;
}

.loader-debug {
  font-family: monospace;
  font-size: 10pt;
  white-space: pre;
  text-align: left;
  position: fixed;
  height: 100vh;
  width: 300px;
  overflow: auto;
  background: #eee;
  top: 0;
  left: 0;
  padding: 1em;
}
</style>
